import { create } from 'twrnc'

const tw = create(require(`./tailwind.config`))

export default tw
